import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export const Navigation: React.FC = () => {
  const location = useLocation();
  const path = location.pathname;

  const active = {
    calculator: path === '/',
    learn: path === '/learn' || path.startsWith('/learn/'),
    faq: path === '/faq',
    about: path === '/about',
    contact: path === '/contact',
  };

  const navLink = (to: string, label: string, isActive: boolean) => (
    <Link
      to={to}
      className={`px-3 py-2 text-sm font-medium transition-colors relative group ${
        isActive ? 'text-gold-300' : 'text-navy-100 hover:text-gold-300'
      }`}
    >
      {label}
      <span
        className={`absolute bottom-0 left-3 right-3 h-0.5 bg-gold-500 transition-transform origin-left ${
          isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
        }`}
      />
    </Link>
  );

  return (
    <header id="app-nav" className="bg-navy-900 sticky top-0 z-50 shadow-panel">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center gap-2">
          <Link
            to="/"
            aria-label="Mortgage Compare Calculator home"
            className="flex items-center gap-2.5 hover:opacity-90 transition-opacity shrink-0"
          >
            <div className="w-8 h-8 rounded-lg bg-gold-500 flex items-center justify-center flex-shrink-0">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="10" width="3" height="6" rx="0.5" fill="#0F1F38"/>
                <rect x="7.5" y="6" width="3" height="10" rx="0.5" fill="#0F1F38"/>
                <rect x="13" y="2" width="3" height="14" rx="0.5" fill="#0F1F38"/>
              </svg>
            </div>
            <span className="font-serif text-lg text-white hidden sm:block tracking-tight">
              Mortgage<span className="text-gold-400">Compare</span>
            </span>
          </Link>

          <nav className="flex items-center flex-wrap justify-end gap-x-0.5 gap-y-1 sm:flex-nowrap">
            {navLink('/', 'Calculator', active.calculator)}
            {navLink('/learn', 'Learn', active.learn)}
            {navLink('/faq', 'FAQ', active.faq)}
            {navLink('/contact', 'Contact', active.contact)}
            {navLink('/about', 'About', active.about)}
          </nav>
        </div>
      </div>
    </header>
  );
};
